import { BooleanInput, SimpleForm, TextInput, maxLength, minLength, required, useTranslate } from 'react-admin';
import { Box } from '@mui/material';
import PropTypes from 'prop-types';
import TagCategoryToolbar from '@/components/global/tags/TagCategoryToolbar.jsx';
import { ParameterComputedInput } from '@/components/parameter/fields/ParameterComputedInput.jsx';
import { ParameterTypeInput } from '@/components/parameter/fields/ParameterTypeInput.jsx';
import { ParameterValueInput } from '@/components/parameter/fields/ParameterValueInput.jsx';
import { ParameterSubsetList } from '@/components/parameter/subsets/ParameterSubsetList.jsx';
import { validateSystemName } from '@/helpers/parameter/parameterValidation.js';
import { normalizeParameterSubsets } from '@/helpers/parameter/parameterSubsets.js';

export const ParameterForm = ({ handleClose }) => {
    const translate = useTranslate();
    const requiredMessage = translate('common.validation.required');

    return (
        <SimpleForm
            defaultValues={record => ({
                subsets: normalizeParameterSubsets(record?.subsets ?? record?.exceptions),
            })}
            toolbar={<TagCategoryToolbar onCancel={handleClose} cancelLabel={translate('common.cancel')} saveLabel={translate('common.save')} />}
        >
            <Box sx={{ width: '100%' }}>
                <TextInput
                    source='name'
                    label={translate('resources.parameter.fields.name')}
                    validate={[
                        required(requiredMessage),
                        minLength(3, translate('common.validation.minLength', { count: 3 })),
                        maxLength(150, translate('common.validation.maxLength', { count: 150 })),
                    ]}
                    fullWidth
                />
                <TextInput
                    source='systemName'
                    label={translate('resources.parameter.fields.systemName')}
                    validate={[
                        required(requiredMessage),
                        minLength(3, translate('common.validation.minLength', { count: 3 })),
                        maxLength(150, translate('common.validation.maxLength', { count: 150 })),
                        value => validateSystemName(value, translate),
                    ]}
                    fullWidth
                />
                <TextInput
                    source='description'
                    label={translate('resources.parameter.fields.description')}
                    validate={maxLength(300, translate('common.validation.maxLength', { count: 300 }))}
                    multiline
                    fullWidth
                />
                <ParameterTypeInput />
                <ParameterValueInput />
                <ParameterComputedInput />
                <Box sx={{ marginLeft: '10px' }}>
                    <BooleanInput source='isActive' label={translate('resources.parameter.fields.isActive')} defaultValue={true} size='small' />
                    <BooleanInput source='isSignificant' label={translate('resources.parameter.fields.isSignificant')} defaultValue={false} size='small' />
                </Box>
                <Box sx={{ mt: 2 }}>
                    <ParameterSubsetList />
                </Box>
            </Box>
        </SimpleForm>
    );
};

ParameterForm.propTypes = {
    handleClose: PropTypes.func,
};
